import React from 'react';
import './App.css';
import Bilderplan from './pages/bilderplan.js'
import './style.scss';
import {HashRouter as Router, Route, Routes} from "react-router-dom";

function App() {
    return (
        <div className="App">
            <Router>
                <Routes>
                    <Route path="/:team" element={<Bilderplan/>}></Route>
                    <Route path="/" element={<Bilderplan/>}></Route>
                </Routes>
            </Router>
        </div>
    );
}

export default App;
